//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SimpleLink'
}
